import { render } from "./PolicySelection.vue?vue&type=template&id=1e926fc7&scoped=true"
import script from "./PolicySelection.vue?vue&type=script&lang=js"
export * from "./PolicySelection.vue?vue&type=script&lang=js"

import "./PolicySelection.vue?vue&type=style&index=0&id=1e926fc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e926fc7"]])

export default __exports__